<template>
  <Toast/>
  <div class="row background-pale sm-pad">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="page-header centrer">
            <div class="row">
              <div class="col-1"/>
              <div class="col-10">
                <h1>Confidentiel </h1>
              </div>
              <div class="col-1 text-right no-print">
                <Button class="no-print" label="Fermer" v-on:click="fermer"/>
              </div>
            </div>
            <h3 class="narration">Narration</h3>
            <div v-show="!isDataLoaded">
              <Skeleton />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <table ref="rapport" id="rapport">
            <thead>
              <tr>
                <td>
                  <!--place holder for the fixed-position header-->
                  <div class="pb-5"></div>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <!--*** CONTENT GOES HERE ***-->
                  <CanevasNarrationCDX0015 @backendError="showError" @isDataLoaded="getIsDataLoaded"/>
                </td>
              </tr>
            </tbody>

            <tfoot>
            <tr>
                <td>
                    <!--place holder for the fixed-position footer-->
                    <div class="page-footer-space"></div>
                </td>
            </tr>
              <tr>
                <td>
                  <!--place holder for the fixed-position footer-->
                  <div class="page-footer-space">
                    <div class="row text-left">
                      <div class="col-2 lbl-left"><label>Créé par : </label></div> <p class="col-6 text-left">{{ narration.creerParDescription }}</p>
                      <div class="col-2 lbl-left"><label>Créé le : </label></div> <p class="col-2 text-left">{{ $commun.formatDateHeure(this.narration.creerLe) }}</p>
                    </div>
                    <div class="row text-left">
                      <div class="col-2 lbl-left"><label>Modifié par : </label></div> <p class="col-6 text-left">{{ narration.modifieParDescription }}</p>
                      <div class="col-2 lbl-left"><label>Modifié le : </label></div> <p class="col-2 text-left">{{ $commun.formatDateHeure(this.narration.modifieLe) }}</p>
                    </div>
                    <div class="row text-left pb-5">
                      <div class="col-2 lbl-left"><label>Approuvé par : </label></div> <p class="col-6 text-left">{{ narration.approuveParDescription }}</p>
                      <div class="col-2 lbl-left"><label>Approuvé le : </label></div> <p class="col-2 text-left">{{ $commun.formatDateHeure(this.narration.approuveLe) }}</p>
                    </div>
                    <div class="row text-left pb-5">
                      <p class="col-5 lbl-left"><label>__________________________________________</label></p> <p class="col-3 text-left"><label>_________________________</label></p> <p class="col-2 text-left"><label>_____________________</label></p>
                      <div class="col-5 text-center"><label>Signature du rédacteur</label></div> <p class="col-3 text-center"><label>Numéro d'employé</label></p> <p class="col-2 text-center"><label>Date</label></p>
                    </div>
                    <div class="row text-left">
                      <p class="col-5 lbl-left"><label>__________________________________________</label></p> <p class="col-3 text-left"><label>_________________________</label></p> <p class="col-2 text-left"><label>_____________________</label></p>
                      <div class="col-5 text-center"><label>Signature du responsable en fonction</label></div> <p class="col-3 text-center"><label>Numéro d'employé</label></p> <p class="col-2 text-center"><label>Date</label></p>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CanevasNarrationCDX0015 from '../../components/narration/Rapport/CanevasNarrationCDX0015.vue'
import axios from "axios";

export default {
  name: "narrationRapportCDX0015",
  components: {
      CanevasNarrationCDX0015,
  },
  data() {
    return {
      isDataLoaded: false,
    };
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle
    this.$root.$refs.breadcrumbComp.ajout("Impression Narration");
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      narration: "narration/narration",
    }),
  },
  methods: {
    getCurrentDateTime() {
      return this.$commun.formatDateHeure(new Date())
    },
    showError(error) {
      this.$toast.add({
        severity: 'error',
        summary: 'Impression annulée',
        detail: 'Erreur lors de la génération de la page: ' + error,
        life: 5000
      })
    },
    getIsDataLoaded(value) {
      this.isDataLoaded = value
    },
    fermer() {
      window.close()
    },
  },
  watch: {
    isDataLoaded: function(value) {
      if (!value)
        return
      // Add a short delay to let Vue finish rendering
      setTimeout(() => {
        window.print();
      }, 3000);
    }
  }

};
</script>

<style scoped>
.sm-pad {
  padding-top: 2em;
}

@media print {
  #rapport {
    min-width: 100%;
  }
  .pb-5 {
    padding-bottom: 130px !important;
  }
  thead {
    min-width: 100%;
  }
  tbody {
    min-width: 100%;
  }
  tfoot {
    display: table-row-group;
    min-width: 100%;
    page-break-inside: avoid;
  }
}
</style>